(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["accordion"] && !Shopify.designMode) return;
  try {
    const checkEmptyAccordions = () => {
    document.querySelectorAll('.accordion').forEach((acc) => {
      const hasItems = acc.querySelector('accordion-custom, details');
      if (!hasItems) {
        const sec = acc.closest('.shopify-section, .section-wrapper, .section');
        if (sec) sec.style.setProperty('display', 'none', 'important');
      }
    });
  };
  checkEmptyAccordions();
  document.addEventListener('DOMContentLoaded', checkEmptyAccordions);
  document.addEventListener('shopify:section:load', checkEmptyAccordions);

  document.addEventListener('toggle', (e) => {
    if (e.target.matches('details[data-accordion-auto-close]') && e.target.open) {
      const parent = e.target.closest('.accordion');
      if (parent) {
        parent.querySelectorAll('details[data-accordion-auto-close]').forEach((item) => {
          if (item !== e.target && item.open) item.open = false;
        });
      }
    }
  }, true);
  } catch(e) { console.error(e); }
})();

})();
